export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13086.cb79f104.jpg";